/* Tema chiaro/scuro condiviso fra dashboard e vista diagramma. Il meccanismo è
   quello dell'originale — `data-theme` sull'elemento radice, che pilota sia le
   variabili del diagramma sia quelle della UI — qui in più viene ricordato. */
export type Theme = "dark" | "light";

const KEY = "fullsteps-theme";

export function savedTheme(): Theme {
  try {
    return localStorage.getItem(KEY) === "light" ? "light" : "dark";
  } catch {
    return "dark"; // storage negato (private browsing): si resta sul default
  }
}

export function applyTheme(theme: Theme): void {
  document.documentElement.setAttribute("data-theme", theme);
  try {
    localStorage.setItem(KEY, theme);
  } catch {
    /* non memorizzabile: il tema vale solo per questa sessione */
  }
}
